import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BBBSeal } from './BBBSeal';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_wall-works-1/artifacts/t9oeun2w_IMG_5700.jpeg" 
              alt="Sat Drywall Ltd" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Your trusted partner for professional drywall and insulation services in commercial and residential projects.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#00AEEF]">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#00AEEF] transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-[#00AEEF] transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#00AEEF] transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-[#00AEEF] transition-colors text-sm">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-gray-300 hover:text-[#00AEEF] transition-colors text-sm">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#00AEEF] transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#00AEEF]">Our Services</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Commercial Drywall</li>
              <li>Residential Drywall</li>
              <li>Mud Tape</li>
              <li>Spray Foam Insulation</li>
              <li>Blow Insulation</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#00AEEF]">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#00AEEF] flex-shrink-0 mt-0.5" />
                <div className="text-sm">
                  <a href="tel:4036044218" className="text-gray-300 hover:text-[#00AEEF] transition-colors block">
                    403-604-4218
                  </a>
                  <a href="tel:4034703018" className="text-gray-300 hover:text-[#00AEEF] transition-colors block">
                    403-470-3018
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#00AEEF] flex-shrink-0 mt-0.5" />
                <a href="mailto:info@sat-drywall.com" className="text-gray-300 hover:text-[#00AEEF] transition-colors text-sm">
                  info@sat-drywall.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-[#00AEEF] flex-shrink-0 mt-0.5" />
                <span className="text-gray-300 text-sm">
                  Mon - Fri: 8:00 AM - 6:00 PM<br/>
                  Sat: 9:00 AM - 4:00 PM
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              &copy; {currentYear} Sat Drywall Ltd. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-end gap-6">
              <a 
                href="https://www.google.com/search?q=Sat+Drywall+Ltd" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#00AEEF] transition-colors text-sm flex items-center gap-2"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                Find us on Google
              </a>
              <span className="text-gray-600">|</span>
              <BBBSeal
                className="w-[230px] max-w-full rounded-xl hover:opacity-90 transition-opacity"
                testId="bbb-seal-footer"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
